import InvoiceList from "../Views/InvoiceZoho/InvoiceZohoList.vue";
import {MODULES} from "../Constants/modules.js";

export const invoiceZohoRoutes = [
    {
        path: "/invoices-zoho",
        name: "invoices-zoho.list",
        component: InvoiceList,
        meta: {
            module: MODULES.INVOICES_ZOHO,
            menu: {
                parent: 'invoices-zoho',
                child: null
            },
            breadcrumb: {
                title: "Factures Zoho",
                nav: {
                    all: {
                        active: "Toutes les factures zoho",
                        inactive: null
                    }
                }
            }
        },
    }
];
